import { useEffect, useState } from 'react';

export const useZendeskWidget = (zendeskWidgetAccountKey: string | null) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    if (!!zendeskWidgetAccountKey) {
      const ZENDESK_WIDGET_ELEMENT_ID = 'ze-snippet';
      const ZENDESK_WIDGET_SRC_SCRIPT = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskWidgetAccountKey}`;

      const script = document.createElement('script');
      script.id = ZENDESK_WIDGET_ELEMENT_ID;
      script.src = ZENDESK_WIDGET_SRC_SCRIPT;
      script.addEventListener('load', () => {
        setIsScriptLoaded(true);
      });
      document.body.appendChild(script);
    }
  }, [zendeskWidgetAccountKey]);

  return { isScriptLoaded };
};
